// regular spring config with clamp
export const mainTransitionConfig = {
  type: 'spring',
  mass: 1,
  damping: 26,
  stiffness: 360,
  velocity: -5,
};

// regular spring config without noticeable clamp
export const secondaryTransitionConfig = {
  type: 'spring',
  mass: 1,
  damping: 36,
  stiffness: 360,
  velocity: -5,
};


// regular spring config without noticeable clamp
export const productsNavigationTransitionConfig = {
  type: 'spring',
  mass: 1,
  damping: 20,
  stiffness: 177.8,
};
